










































































































































import { Component, Vue } from 'vue-property-decorator'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { Loja, TipoDeTransacaoDeVenda, TipoNota, Venda } from '@/models'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import IconesDaToolbarPadroes from '@/components/layout/IconesDaToolbarPadroes.vue'
import BotaoDeDrawer from '@/components/ui/BotaoDeDrawer.vue'

// Na tela a Nota de Crédito de redução de valores (tipo 04) é uma operação própria; na venda ela é Complementar de entrada
const OPERACAO_NOTA_DE_CREDITO = 'Nota de Crédito'
// Do mesmo jeito a Nota de Débito de multa e juros (tipo 04) é uma Complementar de saída
const OPERACAO_NOTA_DE_DEBITO = 'Nota de Débito'
type OperacaoDaEmissao = TipoDeTransacaoDeVenda | 'Retorno Consignado' | typeof OPERACAO_NOTA_DE_CREDITO | typeof OPERACAO_NOTA_DE_DEBITO

@Component({
	components: {
		IconesDaToolbarPadroes,
		SeletorDeLojas,
		BotaoDeDrawer,
	},
})
export default class ToolbarDeEmissaoDeNota extends Vue  {
	mostrarConfirmacao = false
	mensagemConfirmacao = ''
	pendingCallback: (() => void) | null = null
	keyAutocompletes = 0
	OPERACAO_NOTA_DE_CREDITO = OPERACAO_NOTA_DE_CREDITO
	OPERACAO_NOTA_DE_DEBITO = OPERACAO_NOTA_DE_DEBITO

	get tipoOperacao(): OperacaoDaEmissao | undefined {
		if (this.venda?.retornoConsignadoFornecedor) return 'Retorno Consignado'
		if (this.venda?.tipoNotaCredito === '04') return OPERACAO_NOTA_DE_CREDITO
		if (this.venda?.tipoNotaDebito === '04') return OPERACAO_NOTA_DE_DEBITO
		return this.venda?.tipoDeTransacao
	}

	get tipoNota() {
		if (!this.venda) return 'Saída'
		return this.venda.tipoNota
	}

	handleTipoOperacaoChange(tipo: OperacaoDaEmissao) {
		if (!this.venda || !tipo) return
		if (this.venda.itens.length > 0) {
			this.mensagemConfirmacao = 'Ao alterar a operação, os itens da venda serão removidos. Deseja continuar?'
			this.pendingCallback = () => this.aplicarTipoOperacao(tipo)
			this.mostrarConfirmacao = true
			return
		}
		this.aplicarTipoOperacao(tipo)
	}

	aplicarTipoOperacao(tipo: OperacaoDaEmissao) {
		if (!this.venda) return
		const venda = { ...this.venda }
		const eraNotaDeCreditoOuDebito = venda.tipoNotaCredito === '04' || venda.tipoNotaDebito === '04'
		venda.retornoConsignadoFornecedor = tipo === 'Retorno Consignado'
		if (tipo === OPERACAO_NOTA_DE_CREDITO) {
			venda.tipoDeTransacao = 'Complementar'
			venda.tipoNotaCredito = '04'
			venda.tipoNotaDebito = null
			venda.tipoNota = 'Entrada'
		} else if (tipo === OPERACAO_NOTA_DE_DEBITO) {
			venda.tipoDeTransacao = 'Complementar'
			venda.tipoNotaDebito = '04'
			venda.tipoNotaCredito = null
			venda.tipoNota = 'Saída'
		} else {
			venda.tipoDeTransacao = tipo === 'Retorno Consignado' ? 'Devolução' : tipo
			venda.tipoNotaCredito = null
			venda.tipoNotaDebito = null
			// O tipo de nota travado pela operação anterior volta ao padrão da emissão
			if (venda.retornoConsignadoFornecedor || eraNotaDeCreditoOuDebito) venda.tipoNota = 'Saída'
		}
		this.resetarItensEConfiguracoes(venda)
		this.venda = venda
	}

	handleTipoNotaChange(tipo: TipoNota) {
		if (!this.venda || !tipo) return
		if (this.venda.itens.length > 0) {
			this.mensagemConfirmacao = 'Ao alterar o tipo de nota, os itens da venda serão removidos. Deseja continuar?'
			this.pendingCallback = () => this.aplicarTipoNota(tipo)
			this.mostrarConfirmacao = true
			return
		}
		this.aplicarTipoNota(tipo)
	}

	aplicarTipoNota(tipo: TipoNota) {
		if (!this.venda) return
		const venda = { ...this.venda }
		venda.tipoNota = tipo
		this.resetarItensEConfiguracoes(venda)
		this.venda = venda
	}

	resetarItensEConfiguracoes(venda: Venda) {
		// O retorno (03 e 06) é escolhido junto com os itens da devolução, então sai com eles
		if (venda.tipoNotaCredito !== '04') venda.tipoNotaCredito = null
		if (venda.tipoNotaDebito !== '04') venda.tipoNotaDebito = null
		venda.itens = []
		venda.cliente = null
		venda.cpfDoCliente = ''
		venda.exibirCpfNaNota = false
		venda.desconto = null
		venda.resumoDaVendaOrigem = null
		VendaModule.setDescontoEmSerie(null)
		VendaModule.setDigitacaoManualFiscalEmissaoNotas(false)
	}

	confirmarAlteracao() {
		if (this.pendingCallback) {
			this.pendingCallback()
		}
		this.fecharConfirmacao()
	}

	cancelarAlteracao() {
		this.keyAutocompletes++
		this.fecharConfirmacao()
	}

	fecharConfirmacao() {
		this.mostrarConfirmacao = false
		this.mensagemConfirmacao = ''
		this.pendingCallback = null
	}

	limparNota() {
		this.mensagemConfirmacao = 'Deseja limpar a nota atual? Todos os dados serão perdidos.'
		this.pendingCallback = () => {
			VendaModule.iniciarNovaNota({ identificador: '', lojaId: '' })
			this.$router.push({ name: this.$route.name as string, query: {} }).catch(() => { /* */ })
		}
		this.mostrarConfirmacao = true
	}

	get loja(): Loja | null {
		return VendaModule.lojaDaEntrada
	}

	set loja(loja: Loja | null) {
		VendaModule.setLojaDaEntrada(loja)
	}

	get venda(): Venda | null {
		return VendaModule.emissaoEntradaAtual
	}

	set venda(venda: Venda | null) {
		VendaModule.setEmissaoEntradaAtual(venda)
	}

	abrirNotaComplementar() {
		this.$router.push({ name: this.$route.name as string, query: { iniciarComplementar: 'true' } })
	}

	abrirNotaDeCredito() {
		this.$router.push({ name: this.$route.name as string, query: { iniciarNotaDeCredito: 'true' } })
	}

	abrirNotaDeDebito() {
		this.$router.push({ name: this.$route.name as string, query: { iniciarNotaDeDebito: 'true' } })
	}

	get itensTipoNota() {
		const itens = ['Entrada', 'Saída']

		return itens.filter(item => {
			if (
				this.tipoOperacao === 'Transferência' ||
				this.tipoOperacao === 'Transferência com redução' ||
				this.tipoOperacao === 'Consumo' ||
				this.tipoOperacao === 'Ativo' ||
				this.tipoOperacao === 'Venda' ||
				this.tipoOperacao === 'Devolução de Transferência' ||
				this.tipoOperacao === 'Retorno Consignado'
			) return item === 'Saída'
			// A Nota de Crédito é sempre de entrada (NT 2025.002, regra B25-110)
			else if (this.tipoOperacao === OPERACAO_NOTA_DE_CREDITO) return item === 'Entrada'
			// A Nota de Débito é sempre de saída (NT 2025.002, regra B25-120)
			else if (this.tipoOperacao === OPERACAO_NOTA_DE_DEBITO) return item === 'Saída'
			else return item
		})
	}

	get devolucaoBuscada() {
		return this.$route.query.devolucaoBuscada != null ? this.$route.query.devolucaoBuscada === 'true' : false
	}

	get digitacaoManualFiscalEmissaoNotas(): boolean {
		return VendaModule.digitacaoManualFiscalEmissaoNotas
	}

	set digitacaoManualFiscalEmissaoNotas(valor: boolean) {
		VendaModule.setDigitacaoManualFiscalEmissaoNotas(valor)
	}

	get digitacaoManualBloqueadaPorItensNaVenda(): boolean {
		return (this.venda?.itens?.length ?? 0) > 0
	}

	async iniciarNovaEntrada() {
		this.$router
			.push({
				name: this.$route.name as string,
				query: { novaEntrada: 'true' },
			})
			.catch()
	}
}
